import React from "react";

const Loader = () => {
  return (
    <>
      {/* <!-- preloader  --> */}
      <div id="preloader"></div>
    </>
  );
};

export default Loader;
